import {action, observable, runInAction} from 'mobx';
import {ITsCanvasAnnotateService} from '../../services/ts-canvas-annotate/ts-canvas-annotate.service';
import {ITranslate} from '../../services/LocalizationService';
import type {ImageEditorState} from '../ts-image-editor/ts-image-editor.state';

export default class AnnotationBarController {
    @observable isMinimized = false;
    @observable showColorPicker = false;
    @observable showTagsMenu = false;
    private readonly annotateService: ITsCanvasAnnotateService;
    private readonly imageEditorState: ImageEditorState;

    constructor(
        annotateService: ITsCanvasAnnotateService,
        imageEditorState: ImageEditorState,
        public translate: ITranslate
    ) {
        this.annotateService = annotateService;
        this.imageEditorState = imageEditorState;
    }

    @action
    toggleMinimized = () => {
        this.isMinimized = !this.isMinimized;
    };

    @action
    toggleColorPicker = () => {
        this.showColorPicker = !this.showColorPicker;
    };

    @action
    toggleTagsMenu = () => {
        this.showTagsMenu = !this.showTagsMenu;
    };

    @action
    hideColorPicker = () => {
        this.showColorPicker = false;
    };

    @action
    hideTagsMenu = () => {
        this.showTagsMenu = false;
    };

    selectTool = (tool: string, ignoreUnselect?: boolean): void => {
        const currentTool = this.imageEditorState.activeAnnotationTool;

        runInAction(() => {
            if (currentTool === tool && !ignoreUnselect) {
                // deselect
                this.imageEditorState.activeAnnotationTool = 'hand';
            } else {
                this.imageEditorState.activeAnnotationTool = tool;
            }
        });

        // Sync to the annotation service
        this.annotateService?.setTool(this.imageEditorState.activeAnnotationTool);
    };

    isActiveTool = (tool: string): boolean => {
        const activeTool = this.imageEditorState.activeAnnotationTool;

        if (tool === 'hand') {
            return activeTool === null || activeTool === 'hand';
        }

        return tool === activeTool;
    };

    selectTextTag = (text?: string): void => {
        runInAction(() => {
            this.imageEditorState.activeAnnotationTool = 'texttag';
        });
        this.annotateService?.setTool('texttag', text ? {text} : undefined);
        this.hideTagsMenu();
    };

    selectNumTag = (num?: string): void => {
        runInAction(() => {
            this.imageEditorState.activeAnnotationTool = 'numtag';
        });
        this.annotateService?.setTool('numtag', num ? {num} : undefined);
        this.hideTagsMenu();
    };

    setColor = (color: string): void => {
        this.annotateService?.setColor(color);
        this.hideColorPicker();
    };

    get currentColorHash() {
        return this.annotateService?.getColor();
    }
}
